/** Non-loading labels for primary submit buttons (avoid nested ternaries in JSX). */
export function getRegisterStep1SubmitLabel(userType, formData) {
  const isCorporatePg = userType === "professional_guardian" && formData.is_corporate_pg;
  return isCorporatePg ? "Next: Add Team Members" : "Create Account";
}

export function getRegisterStep2SubmitLabel(corporateContactsLength) {
  return corporateContactsLength > 0 ? "Create Account & Invite" : "Create Account";
}
